((app, ng) => {

    app.controller("editAccountStatusController", editAccountStatusController);

    function editAccountStatusController($mdDialog, moment, accountStatusApi) {
        const $ctrl = this;
        $ctrl.ui = {
            saving: false,
        }

        const close = (evt) => {
            $mdDialog.hide(evt);
        }

        const createAccountStatus = (status) => {
            if (!!status.StatusDate) {
                accountStatusApi.createAccountStatus(status).then(response => {
                    status.Id = response.Id;
                    $ctrl.close({ status, evt: "STATUS_ADDED" });
                });
            }
        }

        const updateAccountStatus = (status) => {
            if (!!status.Id) {
                $ctrl.ui.saving = true;

                accountStatusApi.updateAccountStatus(status.Id, status).then(() => {
                    $ctrl.close({ status, evt: "STATUS_UPDATED" });
                });
            }
        }

        const deleteAccountStatus = (statusId) => {
            $ctrl.ui.saving = true;

            accountStatusApi.deleteAccountStatus(statusId).then(() => {
                $ctrl.close({ statusId, evt: "STATUS_DELETED" });
            });
        }

        ng.extend($ctrl,
            {
                close,
                createAccountStatus,
                updateAccountStatus,
                deleteAccountStatus,
            });
    }

})(window.app, window.angular);